import { Hero } from '../components/Hero';
import { ApproachSection } from '../components/ApproachSection';
import { ProblemSection, HowItWorksSection, WhyItMattersSection } from '../components/NarrativeSections';
import { FounderSection, ContactSection, ChainNote } from '../components/ClosingSections';

export default function HomePage() {
  return (
    <main id="main-content" data-testid="home-page">
      <Hero />
      <ProblemSection />
      <ApproachSection />
      <HowItWorksSection />
      <WhyItMattersSection />
      <FounderSection />
      <ContactSection />
      <ChainNote />
    </main>
  );
}
